module.exports = __webpack_public_path__ + "img/sortdropdown.fd2f0ec6.svg";